import {
  ProductProductPricesDetailPage,
  ProductProductsDetailPage,
  ProductProductPriceDetailPage,
  ProductProductPricesListPage,
  ProductProductsListPage,
  ProductUserScaleListPage,
  ProductUserScaleDetailPage,
} from "@Elements";
import { DashboardBaseRoute } from "./Dashboard.route";
import { createRoute, redirect } from "@tanstack/react-router";

export const ProductBaseRoute = createRoute({
  getParentRoute: () => DashboardBaseRoute,
  path: "/product",
  staticData: {
    TITLE: "Ürün Yönetimi",
    IS_BASE_ROUTE: true,
  },
  beforeLoad: (route) => {
    if (route.location.pathname === ProductBaseRoute.fullPath)
      throw redirect({
        to: ProductProductsListRoute.fullPath,
      });
  },
});

export const ProductProductsBaseRoute = createRoute({
  getParentRoute: () => ProductBaseRoute,
  path: "/product",
  beforeLoad: (route) => {
    if (route.location.pathname === ProductProductsBaseRoute.fullPath)
      throw redirect({
        to: ProductProductsListRoute.fullPath,
      });
  },
});

export const ProductProductsListRoute = createRoute({
  getParentRoute: () => ProductProductsBaseRoute,
  path: "/list",
  component: ProductProductsListPage,
  staticData: {
    TITLE: "Ürün Listesi",
  },
});

export const ProductProductsEditRoute = createRoute({
  getParentRoute: () => ProductProductsBaseRoute,
  path: "/edit/$id",
  component: ProductProductsDetailPage,
  staticData: {
    TITLE: "Ürün Düzenle",
    PARENT_ROUTE: ProductProductsListRoute,
  },
});

export const ProductProductsAddRoute = createRoute({
  getParentRoute: () => ProductProductsBaseRoute,
  path: "/add",
  component: ProductProductsDetailPage,
  staticData: {
    TITLE: "Ürün Düzenle",
    PARENT_ROUTE: ProductProductsEditRoute,
  },
});

export const ProductProductPriceEditRoute = createRoute({
  getParentRoute: () => ProductProductsBaseRoute,
  path: "/price/$id",
  component: ProductProductPriceDetailPage,
  staticData: {
    TITLE: "Ürün Fiyatı Düzenle",
    PARENT_ROUTE: ProductProductsListRoute,
  },
});

export const ProductPricesBaseRoute = createRoute({
  getParentRoute: () => ProductBaseRoute,
  path: "/product-prices",
  beforeLoad: (route) => {
    if (route.location.pathname === ProductProductsBaseRoute.fullPath)
      throw redirect({
        to: ProductProductsListRoute.fullPath,
      });
  },
});

export const ProductPricesListRoute = createRoute({
  getParentRoute: () => ProductPricesBaseRoute,
  path: "/list",
  component: ProductProductPricesListPage,
  staticData: {
    TITLE: "Ürün Fiyatları Listesi",
  },
});

export const ProductPricesEditRoute = createRoute({
  getParentRoute: () => ProductPricesBaseRoute,
  path: "/edit/$id",
  component: ProductProductPricesDetailPage,
  staticData: {
    TITLE: "Ürün Fiyatları Düzenle",
    PARENT_ROUTE: ProductPricesListRoute,
  },
});

export const ProductPricesAddRoute = createRoute({
  getParentRoute: () => ProductPricesBaseRoute,
  path: "/add",
  component: ProductProductPricesDetailPage,
  staticData: {
    TITLE: "Ürün Fiyatları Düzenle",
    PARENT_ROUTE: ProductPricesListRoute,
  },
});

export const ProductUserScaleBaseRoute = createRoute({
  getParentRoute: () => ProductBaseRoute,
  path: "/user-scale",
  beforeLoad: (route) => {
    if (route.location.pathname === ProductProductsBaseRoute.fullPath)
      throw redirect({
        to: ProductProductsListRoute.fullPath,
      });
  },
});

export const ProductUserScaleListRoute = createRoute({
  getParentRoute: () => ProductUserScaleBaseRoute,
  path: "/list",
  component: ProductUserScaleListPage,
  staticData: {
    TITLE: "Kullanıcı Barem Listesi",
  },
});

export const ProductUserScaleEditRoute = createRoute({
  getParentRoute: () => ProductUserScaleBaseRoute,
  path: "/edit/$id",
  component: ProductUserScaleDetailPage,
  staticData: {
    TITLE: "Kullanıcı Barem Düzenle",
    PARENT_ROUTE: ProductUserScaleListRoute,
  },
});

export const ProductUserScaleAddRoute = createRoute({
  getParentRoute: () => ProductUserScaleBaseRoute,
  path: "/add",
  component: ProductUserScaleDetailPage,
  staticData: {
    TITLE: "Kullanıcı Barem Ekle",
    PARENT_ROUTE: ProductUserScaleListRoute,
  },
});

export const ProductRouteTree = ProductBaseRoute.addChildren([
  ProductProductsBaseRoute.addChildren([
    ProductProductsListRoute,
    ProductProductsAddRoute,
    ProductProductsEditRoute,
    ProductProductPriceEditRoute,
  ]),
  ProductPricesBaseRoute.addChildren([
    ProductPricesListRoute,
    ProductPricesEditRoute,
    ProductPricesAddRoute,
  ]),
  ProductUserScaleBaseRoute.addChildren([
    ProductUserScaleListRoute,
    ProductUserScaleEditRoute,
    ProductUserScaleAddRoute,
  ]),
]);
